import { render, staticRenderFns } from "./PageList.vue?vue&type=template&id=5d695104&scoped=true"
import script from "./PageList.vue?vue&type=script&lang=js"
export * from "./PageList.vue?vue&type=script&lang=js"
import style0 from "./PageList.vue?vue&type=style&index=0&id=5d695104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d695104",
  null
  
)

export default component.exports